<template>
<div>
  <section class="subHeaderGest">
    <XCerrar/>
    <div></div>
    <h2>{{ nombreGestion }}</h2>
  </section>
</div>
</template>

<!-- <div class="gestion"><h4>Gestión colecciones -> </h4> </div> -->

<script>
import XCerrar from '../components/XCerrar.vue'
export default {
  components: { XCerrar },
  name: 'SubHeaderGestion',
  props: ['nombreGestion']
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
section.subHeaderGest {
  height: 8vh;
  background-color: var(--az-me-tr07);
  /* background-color: rgba(30, 85, 130, 0.8); */
  color: rgb(255, 255, 255);
  display: grid;
  grid-template-columns: 1fr 80vw;
  align-items:center;
  justify-items: left;
}
.subHeaderGest{
  z-index: 5;
  box-shadow: rgb(2, 2, 2) 0px 0px 15px;
  position: relative;
}
section.subHeaderGest h2 {
  font-weight: bold;
  color: var(--na);
  padding-left: 2%;
  text-align: left;
}
.gestion{
  display:flex;
  justify-self: right;
  padding-right: 2%;
}
section.subHeaderGest h4 {
  font-weight: lighter;
  color: rgb(255, 255, 255);
}
@media screen and (max-width: 575px){
  .gestion {
    display: none;
  }
  section.subHeaderGest {
  display: flex;
  height: 7vh;
  /* align-items:center;
  justify-items: left; */
}
  section.subHeaderGest h2 {
    padding-left: 5vw;
    padding-bottom: 2vw;
    padding-top: 2vw;
    text-align: left;
    font-weight:500;
    line-height: 105%;
    max-width: 80%;
  }
}
@media screen and (max-width: 375px){

  section.subHeaderGest {
    height: 8vh;
  }
  section.subHeaderGest h2 {
    font-size: 108%;
    /* padding-left: 5vw;
    padding-bottom: 2vw;
    padding-top: 2vw;
    font-weight:500;*/
    line-height: 110%;
  }
}
</style>
